import { createMutation } from "react-query-kit";
import type { MutationFunction } from "@tanstack/react-query";

import type { IMemberAchievements } from "./routeType";

import { axiosClient, queryClient } from "@api/clients.ts";
import { getApi } from "@api/apiPath";
import { useGetAllMemberAchievements } from "@/api/members/achievements/getAll";
import { useGetMemberAchievement } from "@/api/members/achievements/get";
import type { IPickMutation } from "@/api";

const { getPath } = getApi("members.achievements.post");

type IExtractedRouteType = IMemberAchievements["achievementSingleCreate"];

export type IPostMemberAchievement = IPickMutation<IExtractedRouteType>;

const postMemberAchievement: MutationFunction<
  IPostMemberAchievement["response"],
  IPostMemberAchievement["variables"]
> = ({ memberId, ...data }) => {
  return axiosClient.post(getPath({ memberId }), data);
};

export const usePostMemberAchievement = createMutation({
  mutationFn: postMemberAchievement,
  onSuccess: (_, { memberId }) => {
    queryClient.invalidateQueries({
      queryKey: useGetAllMemberAchievements.getKey(),
    });
    queryClient.invalidateQueries({
      queryKey: useGetMemberAchievement.getKey({ memberId }),
    });
  },
});
